// ExportButton.jsx
import { BuildAndExportPdf } from "./pdfBuilder";
import useApi from "../../Hooks/useApi";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

export default function ExportButton({ cityId, year, disabled = false }) {
  const { request } = useApi({ isPublic: true });
  const [isLoading, setIsLoading] = useState(false);

  const onExport = async () => {
    if (disabled) return; // Extra safety
    setIsLoading(true);
    try {
      await BuildAndExportPdf({ cityId, year, request });
    } catch (err) {
      console.error("PDF generation failed:", err);
    } finally {
      setIsLoading(false);
    }
  };
return (
    <button
      onClick={onExport}
      className={`flex items-center gap-2 px-3 py-1 h-9 pr-2 text-sm font-medium transition-all bg-red-100 text-red-700 rounded hover:bg-red-200 disabled:opacity-50 ${
        disabled || isLoading ? "cursor-not-allowed" : "cursor-pointer"
      }`}
      disabled={isLoading || disabled}
      title={disabled ? "PDF export is disabled in city comparison." : ""}
    >
      <FontAwesomeIcon
        icon={faFilePdf}
        className="w-4 h-4"
        spin={isLoading}
      />
      {isLoading ? "Exporting..." : "Export City as PDF"}
    </button>
  );
}
